var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3174a7",
    strokeWidth: 1.8,
    d: "m13.229 7.11 3.661 3.661L18.163 9.5l-3.662-3.662L13.23 7.11Zm-7.324 7.323 3.662 3.662 1.272-1.273-3.661-3.661-1.273 1.272ZM18.72 4.546l.732.733c.863.862.863 2.26 0 3.121L8.67 19.185l-4.68.826.826-4.68L15.6 4.546a2.207 2.207 0 0 1 3.121 0Z"
  })));
};
export default SvgEdit;